import { paywallStore } from '@stores/Paywall';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Where Stripe sends the user back after checkout (`/payment/success`, `/payment/failed`).
 * Nothing to show: it records the outcome for the paywall and lands in the app, where the
 * gate decides what the user sees — the wall confirming the payment, or the workspace.
 *
 * A walled tab goes straight to the wall rather than bouncing off the workspace. For an
 * entitled one, `?refresh_credits=1` on the success landing reuses the app-level handler
 * that refetches billing and tells the other tabs to re-read it, which is what an in-app
 * purchase that opened Stripe in a new tab needs.
 */
export const PaymentReturnPage = ({ outcome }: { outcome: 'success' | 'failed' }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (outcome === 'success') {
      paywallStore.markCheckoutReturned();
    } else {
      paywallStore.cancelPendingCheckout();
    }
    if (paywallStore.isWalled) {
      navigate('/subscribe', { replace: true });
    } else {
      navigate(outcome === 'success' ? '/workspace?refresh_credits=1' : '/workspace', {
        replace: true,
      });
    }
  }, [outcome, navigate]);

  return null;
};
